import React from "react";
import { colors } from "sweet-web/lib/styles";

type Props = {
  size?: number;
  style?: object;
  color?: string;
};
const LogoIcon: React.FC<Props> = props => {
  return (
    <span style={props.style}>
      <svg
        width={String(props.size)}
        height={String(props.size)}
        viewBox="0 0 133 233"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M71.3462 81.4161C82.2949 81.4161 93.1538 83.023 103.923 86.2368C114.692 89.4506 124.385 93.9141 133 99.6276L103.923 134.176C99.4359 131.319 94.859 129.087 90.1923 127.48C85.5256 125.874 80.9487 125.07 76.4615 125.07C73.4102 125.07 70.8974 125.472 68.9231 126.275C66.9487 127.079 65.9615 128.641 65.9615 130.962C65.9615 132.748 67.0833 134.131 69.3269 135.113C71.4258 136.032 76.077 137.224 83.2808 138.689L84.8077 138.997C90.3718 140.068 95.8013 141.719 101.096 143.951C106.391 146.183 111.147 149.04 115.365 152.521C119.583 156.003 122.949 160.243 125.462 165.243C127.974 170.242 129.231 176.134 129.231 182.918C129.231 192.381 127.212 200.326 123.173 206.754C119.135 213.182 114.019 218.315 107.827 222.153C101.635 225.992 94.859 228.76 87.5 230.456C80.141 232.152 73.1411 233 66.5 233C54.2948 233 42.3142 231.259 30.5577 227.778C18.8012 224.296 8.61543 219.341 0 212.914L30.4231 177.83C34.7308 181.758 39.8013 184.927 45.6346 187.337C51.468 189.748 57.0769 190.953 62.4615 190.953C64.6154 190.953 66.6346 190.551 68.5192 189.748C70.4039 188.944 71.3462 187.471 71.3462 185.329C71.3462 183.008 69.6859 181.178 66.3654 179.839C63.0449 178.499 57.2565 176.848 49 174.884C44.5128 173.813 39.9359 172.25 35.2692 170.197C30.6025 168.144 26.3398 165.421 22.4808 162.029C18.6218 158.636 15.4359 154.485 12.9231 149.575C10.4102 144.665 9.15385 138.818 9.15385 132.033C9.15385 122.928 11.1731 115.161 15.2115 108.733C19.25 102.306 24.3654 97.0834 30.5577 93.0661C36.75 89.0488 43.4807 86.1029 50.75 84.2282C58.0193 82.3534 64.8846 81.4161 71.3462 81.4161ZM68.8221 0C86.4793 0 100.793 14.2388 100.793 31.8032C100.793 49.3676 86.4793 63.6063 68.8221 63.6063C51.1649 63.6063 36.851 49.3676 36.851 31.8032C36.851 14.2388 51.1649 0 68.8221 0Z"
          fill={props.color}
        />
      </svg>
    </span>
  );
};
LogoIcon.defaultProps = {
  color: colors.primary,
  size: 16
};

export default LogoIcon;
